<template>
  <div class="page">
    <!-- 头部 -->
    <YorkbbsHeader :width="'1170px'"></YorkbbsHeader>

    <!-- 搜索/导航 -->
    <YorkbbsSearchNav :topicVisible="false"></YorkbbsSearchNav>

    <div class="page-wrapper">
      <!-- 面包屑 -->
      <YorkbbsBreadcrumb>
        <el-breadcrumb-item to="/">约克黄页</el-breadcrumb-item>
        <el-breadcrumb-item :to="`/list/${topTopic.englishName}`">{{ topTopic.name }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="`/list/${topic.englishName}`">{{ topic.name }}</el-breadcrumb-item>
        <el-breadcrumb-item>正文</el-breadcrumb-item>
      </YorkbbsBreadcrumb>

      <template v-if="$store.getters.user.id === post.user.id && post.property.payType == 4">
        <div class="alert" v-if="[0].includes(post.property.status) && !topic.payTypes.includes(4)">
          <div class="alert-left">
            <i class="yk-light"></i>
            <span>该黄页为付费栏目，定制广告后才能公开发布。目前您的黄页处于隐藏中，仅自己可见。</span>
          </div>
          <div class="alert-right">
            <a class="alert-more" :href="`/detail/${$route.params.id}` | hostBuild('merchant')" target="_blank">
              <span>立即付费展示</span>
              <i class="el-icon-arrow-right"></i>
            </a>
          </div>
        </div>
        <div class="alert" v-else-if="
          [-2, -1, -4].includes(post.property.status) && !topic.payTypes.includes(1) && !topic.payTypes.includes(2)
        ">
          <div class="alert-left">
            <i class="yk-light"></i>
            <span>该黄页为免费栏目，需要审核后才能公开发布。目前您的黄页处于隐藏中，仅自己可见。</span>
          </div>
          <div class="alert-right"></div>
        </div>
        <div class="alert" v-else-if="[-2, -1, -4].includes(post.property.status) && !topic.payTypes.includes(4)">
          <div class="alert-left">
            <i class="yk-light"></i>
            <span>该黄页为付费栏目，定制广告后才能公开发布。目前您的黄页处于审核中，仅自己可见。</span>
          </div>
          <div class="alert-right"></div>
        </div>
      </template>
    </div>

    <!-- 头图 付费300时显示 -->
    <template v-if="showModule(6)">
      <div class="page-banner__list" v-if="post.property.optimized == 1 && listImage.length">
        <YorkbbsImage class="page-banner__item" v-for="i in 5" :key="i" width="100%" height="100%"
          :src="listImage[i - 1]" :preview-src-list="listImage.slice(0, 5)"></YorkbbsImage>
      </div>
    </template>
    <div class="page-wrapper">
      <!-- 门面 -->
      <div class="front">
        <div class="front-left">
          <!-- 标题 -->
          <div class="title-wrapper">
            <img class="label-optimized" :src="require('@/assets/images/info/optimized.png')" alt="优选"
              v-if="post.property.optimized == 1" />
            <h2 class="closure" v-if="permanentClosure">【永久歇业】</h2>
            <h2 class="shopname" v-if="post.property.shopCnName && post.property.shopCnName != post.title"
              v-html="post.property.shopCnName"></h2>
            <h2 class="shopname" v-if="post.property.shopEnName" v-html="post.property.shopEnName"></h2>
            <span class="front-divider"
              v-if="(post.property.shopCnName || post.property.shopEnName) && post.property.shopCnName != post.title"></span>
            <h1 class="title" v-html="post.title"></h1>
            <img class="label-vip" :src="require('@/assets/images/info/vip.png')" alt="VIP"
              v-if="[1, 2].includes(post.property.payType)" />
            <!-- <span class="label-unauth" v-else>未认证</span> -->
            <span class="label-year" v-if="post.property.registYear">入驻{{ post.property.registYear }}年</span>
            <span class="label-year" v-else>最新入驻</span>
          </div>

          <!-- 联系方式，收藏，分享 -->

          <ul class="interact">
            <li v-if="post.property.contactNumber">
              <el-popover placement="bottom-start" width="350" trigger="hover">
                <el-button slot="reference" type="danger">
                  <div class="phone-row"><img :src="require('@/assets/images/job/phone-white.png')" alt="" height="20">
                    {{ post.property.contactNumber | phoneFormat }}</div>
                </el-button>
                <div class="popover-contact">

                  <div class="phone-copy">
                    <div class="phone">{{ post.property.contactNumber | phoneFormat }}</div>
                    <div class="copy" v-clipboard:copy="post.property.contactNumber"
                      v-clipboard:success="() => $success('复制成功')">复制</div>
                  </div>
                  <div class="note">联系我时，请说是在约克论坛看到的。</div>
                </div>
              </el-popover>
            </li>
            <li>
              <a target="_blank" :href="chatURL" v-if="isLogin">
                <el-button plain>
                  <div class="report-row"><img :src="require('@/assets/images/job/msg.png')" alt=""> 私信</div>
                </el-button>
              </a>
              <el-button plain @click="$store.commit('showLoginDialog')" v-else>
                <div class="report-row"><img :src="require('@/assets/images/job/msg.png')" alt=""> 私信</div>
              </el-button>
            </li>
            <li v-if="post.property.email">
              <el-popover placement="bottom-start" width="400" trigger="hover">
                <el-button slot="reference" plain>
                  <div class="report-row">
                    <img :src="require('@/assets/images/job/email.png')" alt="">
                    Email
                  </div>
                </el-button>
                <div class="popover-email">
                  <div class="email-cont">{{ post.property.email }}</div>
                  <div class="copy" v-clipboard:copy="post.property.email" v-clipboard:success="() => $success('复制成功')">
                    复制
                  </div>
                  <a class="send-email" :href="'mailto:' + post.property.email">发送Email</a>
                </div>
              </el-popover>
            </li>
            <li v-if="post.property.weChatId || post.property.weChatQrcode">
              <el-popover placement="bottom-start" width="400" trigger="hover">
                <el-button slot="reference" plain>
                  <div class="report-row">
                    <img :src="require('@/assets/images/job/wx.png')" alt="">
                    微信号
                  </div>
                </el-button>
                <div class="popover-email">
                  <div class="email-cont" v-if="post.property.weChatQrcode">
                    <img :src="post.property.weChatQrcode" class="qrcode-pic">
                  </div>
                  <div class="email-cont">{{ post.property.weChatId }}</div>
                  <div class="copy" v-clipboard:copy="post.property.weChatId"
                    v-clipboard:success="() => $success('复制成功')" v-if="post.property.weChatId">复制</div>

                </div>
              </el-popover>
            </li>
            <li v-loading="favoriteLoading">
              <div class="collect-btn" @click="collectChange">
                <img :src="require('@/assets/images/common/collect-active.png')" alt="" v-if="post.property.isFavorite">
                <img :src="require('@/assets/images/common/collect-default.png')" alt="" v-else>
                收藏
              </div>
            </li>
            <li>
              <YorkbbsWechatSharePopover placement="bottom">
                <el-button plain>
                  <div class="report-row"><img :src="require('@/assets/images/job/share.png')" alt=""> 分享</div>
                </el-button>
              </YorkbbsWechatSharePopover>
            </li>
          </ul>


          <!-- 联系人/地址/网址/营业时间 -->
          <div class="concat-info__list">
            <div class="concat-info__item" v-if="post.property.claim == 1 && post.property.contactName">
              <div class="concat-info__label">联系人</div>
              <div class="concat-info__content">{{ post.property.contactName }}</div>
            </div>
            <div class="concat-info__item" v-if="post.property.address">
              <div class="concat-info__label">地址</div>
              <div class="concat-info__content">
                <span><a :href="'https://www.google.com/maps/place/'+post.property.address" target="_blank">{{ post.property.address }}</a></span>
                <button class="button-copy" v-clipboard:copy="post.property.address"
                  v-clipboard:success="() => $success('复制成功')">
                  复制
                </button>
              </div>
            </div>
            <div class="concat-info__item" v-if="post.property.website">
              <div class="concat-info__label">网址</div>
              <div class="concat-info__content">
                <a class="concat-website" :href="post.property._website"
                  :rel="linkNeedAddRel(post.property._website) && 'nofollow'" target="_blank">{{ post.property.website
                  }}</a>
              </div>
            </div>
            <div class="concat-info__item" v-if="operTimes.length && !permanentClosure">
              <div class="concat-info__label">营业时间</div>
              <div class="concat-info__content">
                <div class="concat-info__time">
                  <span class="concat-status">{{ post.property.businessStatus == 1 ? '营业中' : '休息中' }}</span>
                  <div>
                    <div class="concat-time" v-if="post.property.operTimes" v-show="!moreOperTimeVisible">
                      {{ curBusinessTime }}
                    </div>
                    <div v-show="moreOperTimeVisible">
                      <template v-for="(sup, i) in operTimes">
                        <div class="concat-time" :key="i">{{ sup.weekend }} {{ sup.timeStr }}</div>
                      </template>
                    </div>
                  </div>
                  <template v-if="operTimes.length">
                    <button class="concat-button__more" v-show="!moreOperTimeVisible"
                      @click="moreOperTimeVisible = true">
                      <i class="el-icon-arrow-down"></i>
                    </button>
                    <button class="concat-button__more" v-show="moreOperTimeVisible"
                      @click="moreOperTimeVisible = false">
                      <i class="el-icon-arrow-up"></i>
                    </button>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="info-ranking" v-if="post.property.rankings">
            <a :href="`/rank/info/${item.name_en}`" target="_blank" class="rank-num" v-for="item in rankingList"
              :key="item.id">
              <img :src="require('@/assets/images/info/york-rank.png')" alt="" class="yorkg-rank">
              <span class="rank-name">{{ item.name }}</span> 第{{ item.rank }}名
              <img :src="require('@/assets/images/info/arrow-right.png')" alt="" class="arr-lr">
            </a>
          </div>

        </div>

        <div class="front-right">
          <!-- 图集 -->
          <YorkbbsImage class="front-images" :src="logo | webpFormat(300)" :preview-src-list="imageList">
            <button class="front-button__images" v-if="post.property.libImageCount > 0">
              <i class="yk-picture"></i>
              <span>{{ post.property.libImageCount }}</span>
            </button>
          </YorkbbsImage>


        </div>
      </div>
    </div>

    <div class="main-wrapper">
      <div class="page-left">
        <!-- 为你优选 -->
        <YorkbbsPrefer v-if="detailModuleList.length > 0 && showModule(1)"></YorkbbsPrefer>

        <!-- 商家简介  -->
        <div class="detail">
          <template v-if="showModule(4)">
            <h3 class="detail-header">服务特色</h3>
            <ul class="detail-tag__list">
              <li class="detail-tag__item" v-for="(item, i) in post.property.topicTags" :key="`topic-${i}`">
                {{ item.name }}
              </li>
              <li class="detail-tag__item" v-for="(item, i) in post.property.customTags" :key="`custom-${i}`">
                {{ item.name }}
              </li>
            </ul>
          </template>

          <template v-if="post.content">
            <h3 class="detail-header">商家简介</h3>
            <div class="editor-txt-content detail-content" v-html="ContentLinkAddRel(post.content)"></div>

            <!-- 详情图片预览 -->
            <YorkbbsImagePreview ref="imagePreview"></YorkbbsImagePreview>
          </template>
        </div>
        <!-- 无简介 -->
        <div class="detail-empty" v-if="!post.content">
          <div class="detail-header">商家简介</div>
          <div class="detail-empty__tip">
            <i class="yk-empty"></i>
            <div>这个商家很懒，什么也没有发布</div>
          </div>
        </div>

        <!-- 举报 -->
        <!-- <YorkbbsReportCard text="所有黄页信息均由用户自行发布，约克论坛不承担任何法律责任，请您慎重辨别信息的合法性和真实性。" @buttonClicked="reportVisible = true"> -->
        <!-- </YorkbbsReportCard> -->
        <CommentList :post="post" v-if="post.id && post.property.showComment" />
      </div>
      <div class="page-right">
        <!-- 地图导航 -->
        <YorkbbsMapNavigator :post="post" v-if="post.property.address"></YorkbbsMapNavigator>
        <!-- 用户信息 -->
        <YorkbbsUserCard v-if="post.property.claim == 1" :user="{
          id: post.user.id,
          avatar: post.user.avatar,
          username: post.user.username,
          registerTime: post.user.registerTime,
          latestVisitTime: post.user.latestVisitTime,
        }" :focusedByMe.sync="post.property.focusedByMe"></YorkbbsUserCard>
        <!-- 门店认领 -->
        <YorkbbsShopClaim v-if="post.property.claim == 0"></YorkbbsShopClaim>
        <!-- 发送邮件 -->
        <template v-if="showModule(5)">
          <YorkbbsShopEmail :post="post" v-if="post.property.email"></YorkbbsShopEmail>
        </template>
        <!-- 优质商家 -->
        <!-- <template v-if="showModule(3)">
          <YorkbbsShopAd :adv="adv"></YorkbbsShopAd>
        </template> -->
      </div>
    </div>

    <div class="page-wrapper" v-if="showModule(2) && post.id">

      <!-- 小伙伴们还喜欢 -->
      <!-- <AlgoliaRecommend :post="post" /> -->
      <YorkbbsOurLike :postInfo="post"></YorkbbsOurLike>
    </div>

    <!-- 举报对话框 -->
    <YorkbbsReportDialog :visible.sync="reportVisible" :list="reportList"></YorkbbsReportDialog>

    <!-- 返回顶部 -->
    <YorkbbsBackup :publishVisible="true" :publishTitle="'免费发布'" :publishURL="'/publish'" :merchantVisible="true"
      :opinionVisible="true"></YorkbbsBackup>

    <!-- 底部 -->
    <YorkbbsFooter class="page-footer"></YorkbbsFooter>
  </div>
</template>
<script>
import { bannerAdvConvert, htmlStringImage2Watermark, setHtmlMeta, phoneFormat, ContentLinkAddRel, linkNeedAddRel, hostBuild } from '@/utils/utils';
import YorkbbsHeader from '@/common/header/header.vue';
import YorkbbsSearchNav from '../components/search-nav.vue';
import YorkbbsBreadcrumb from '@/common/breadcrumb.vue';
import YorkbbsPrefer from './prefer.vue';
import YorkbbsOurLike from './our-like.vue';
import YorkbbsFooter from '@/common/footer/footer.vue';
import YorkbbsMapNavigator from './map-navigator.vue';
import YorkbbsUserCard from '@/common/card-user.vue';
import YorkbbsShopClaim from './shop-claim.vue';
import YorkbbsShopEmail from './shop-email.vue';
import YorkbbsWechatPopover from '../components/popover-wechat.vue';
import YorkbbsPhoneSharePopover from '@/common/popover-share-phone.vue';
import YorkbbsWechatSharePopover from '@/common/popover-share-wechat.vue';
import YorkbbsReportDialog from '@/common/dialog-report.vue';
import YorkbbsBackup from '@/common/tools-backup.vue';
import YorkbbsReportCard from '@/common/card-report.vue';
import YorkbbsImagePreview from '@/common/image-preview.vue';
import CommentList from '../components/commentList.vue'
//import AlgoliaRecommend from './algolia-recommend.vue'
export default {
  name: 'Detail',
  components: {
    YorkbbsHeader,
    YorkbbsSearchNav,
    YorkbbsBreadcrumb,
    YorkbbsPrefer,
    YorkbbsOurLike,
    YorkbbsFooter,
    YorkbbsMapNavigator,
    YorkbbsUserCard,
    YorkbbsShopClaim,
    YorkbbsShopEmail,
    YorkbbsWechatPopover,
    YorkbbsPhoneSharePopover,
    YorkbbsWechatSharePopover,
    YorkbbsReportDialog,
    YorkbbsBackup,
    YorkbbsReportCard,
    YorkbbsImagePreview,
    CommentList,
    //AlgoliaRecommend
  },
  data() {
    return {
      // 黄页信息加载状态
      loading: false,
      // 收藏价值状态
      favoriteLoading: false,
      // 黄页信息
      post: {
        title: '',
        content: '',
        adEndDt: '',
        rankNum: 1,
        location: {
          lat: undefined,
          lon: undefined,
        },
        property: {
          focusedByMe: 0,
          address: '',
          website: '',
          contactName: '',
          contactNumber: '',
          _contactNumber: '', // 被隐藏的手机号码
          topics: [],
          payType: 0, // 付费类型 1竞价 2时长 3推广 4免费
          optimized: 0, // 是否是优选信息
          operTimes: undefined,
          isFavorite: false, // 是否已收藏
          coverImage: '', // 封面图
          listImage: [],
          libImageCount: 0, // 图集数量
          topicTags: [],
          customTags: [],
          claim: 0, // 是否认领，
          rankings: [],
        },
        user: {
          id: '',
          avatar: '',
          username: '',
          registerTime: '',
          latestVisitTime: '',
        },
      },
      //详情模块列表
      detailModuleList: [],
      // 更多营业时间显示状态
      moreOperTimeVisible: false,

      // 手机号码显示状态
      telVisible: false,

      // 图集列表
      imageList: [],

      // 举报对话框显示
      reportVisible: false,

      // 举报选项列表
      reportList: [
        { name: '信息错误' },
        { name: '虚假宣传' },
        { name: '虚假评论' },
        { name: '垃圾广告' },
        { name: '其他' },
      ],
      // 广告
      adv: {},
    };
  },
  computed: {
    // 是否常用电话
    isChinesePhone() {
      return this.topTopic.englishName === "chinesephone";
    },
    // 是否已登录
    isLogin() {
      return this.$store.getters.isLogin;
    },
    // 当前信息所在二级版块
    topic() {
      return this.post.property.topics[0] || {};
    },
    // 当前信息所在一级板块
    topTopic() {
      return this.topic.parent || {};
    },
    // LOGO
    logo() {
      return this.post.property.logo || this.post.property.coverImage;
    },
    // 列表图
    listImage() {
      return this.post.property.listImage;
    },
    // 营业时间
    operTimes() {
      const operTimes = this.post.property.operTimes || {};
      const weekends = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
      return Object.keys(operTimes)
        .filter(key => operTimes[key] != null)
        .reduce(
          (list, key) => [
            ...list,
            {
              weekend: weekends[key],
              timeStr: (operTimes[key] || []).map(item => `${item.beginTime} - ${item.endTime}`).join(', '),
            },
          ],
          [],
        );
    },
    // 当前营业时间
    curBusinessTime() {
      const curBusinessTime = this.post.property.curBusinessTime;
      const weekends = ['周一', '周二', '周三', '周四', '周五', '周六','周日'];

      if (curBusinessTime) {
        return `${weekends[new Date().getDay()]}  ${curBusinessTime.beginTime} - ${curBusinessTime.endTime}`;
      } else {
        return '';
      }
    },
    rankingList() {
      let rankList = this.post.property.rankings;
      return rankList.sort((a, b) => b - a)
    },
    //永久歇业
    permanentClosure() {
      return this.post.property.status === -5;
    },
    chatURL() {
      return hostBuild(`/chat?to=${this.post.user.id}`, 'home');
    },
  },
  created() {
    this.getPost();
    this.getImageList();
    this.getAdvList();
  },
  beforeDestroy() {
    if (document.getElementById('meta-noindex')) {
      document.getElementsByTagName('head')[0].removeChild(document.getElementById('meta-noindex'));
    }
  },
  methods: {

    linkNeedAddRel(data) {
      return linkNeedAddRel(data);
    },
    ContentLinkAddRel(data) {
      return ContentLinkAddRel(data)
    },
    showModule(id) {
      if (this.detailModuleList.length == 0) {
        return true;
      } else {
        return this.detailModuleList.includes(id);
      }
    },
    /**
     * 获取图集
     */
    async getImageList() {
      const { data } = await this.$axios.post('/user/v1/get/user/media', {
        mediaType: 1,
        postId: this.$route.params.id,
      });
      this.imageList = data.map(item => item.mediaUrl);
    },
    /**
     * 收藏
     */

    collectChange() {
      if (this.post.property.isFavorite) {
        //取消收藏
        this.removeFavorite();
      } else {
        this.addFavorite();
      }
    },
    async addFavorite() {
      if (!this.isLogin) return this.$store.commit('showLoginDialog');

      if (this.favoriteLoading) return;

      this.favoriteLoading = true;
      await this.$axios
        .post('/info/v1/add/post/favorite/item', {
          postId: this.$route.params.id,
        })
        .finally(() => {
          this.favoriteLoading = false;
        });

      this.$success('收藏成功');
      this.post.property.isFavorite = true;
    },
    /**
     * 取消收藏
     */
    async removeFavorite() {
      if (!this.isLogin) return this.$store.commit('showLoginDialog');

      if (this.favoriteLoading) return;

      this.favoriteLoading = true;
      await this.$axios
        .post('/info/v1/remove/post/favorite/item', {
          ids: [this.$route.params.id],
        })
        .finally(() => {
          this.favoriteLoading = false;
        });

      this.$success('取消收藏成功');
      this.post.property.isFavorite = false;
      this.post.property.favorite -= 1;
    },
    /**
     * 获取黄页详情
     */
    async getPost() {
      this.loading = true;
      const { code, msg, data } = await this.$axios
        .post('/info/v1/get/post/detail', {
          postId: this.$route.params.id,
        })
        .finally(() => {
          this.loading = false;
        });

      if (code == -3) {
        this.$error(msg);
        return this.$router.replace('/');
      }
      if (data.property.status == -3) {
        const meta = document.createElement('meta');
        meta.id = "meta-noindex";
        meta.name = "googlebot";
        meta.content = "noindex";
        document.getElementsByTagName('head')[0].appendChild(meta);
      }
      // 如果是店铺或饭店，跳转到对应的详情页
      if( data.property.topics[0].businessType.id > 1 ){
        let bizName = data.property.merchantId? data.property.merchantId: data.id;
        let url = '/'+data.property.topics[0].businessType.name_en + '/' + data.property.topics[0].englishName + '/'+ bizName;        
        this.$router.replace(url);
      }
      // 处理地址
/*       data.property.address = [data.property.address, data.property.cityName, data.property.postcode]
        .filter(item => !!item)
        .join(', '); */

      // 处理联系电话
      const contactNumber = (data.property.contactNumber || '').replace(/\D/g, '');
      data.property.contactNumber = contactNumber;
      data.property._contactNumber = contactNumber.slice(0, 3) + '-***-' + contactNumber.slice(-4);

      // 处理网址
      data.property._website = /^http|\/\//.test(data.property.website)
        ? data.property.website
        : 'http://' + (data.property.website || '');
      // 添加水印
      data.content = htmlStringImage2Watermark(data.content);

      this.post = { ...this.post, ...data };
      this.detailModuleList = this.post.property.topics[0].detailModul;
      console.log('获取详情后----》', this.post)
      await this.$nextTick();

      // 图片预览
      this.$refs.imagePreview.init();

      let shopNameStr = '';
      let descriptionStr = '';
      if (data.property.shopCnName && data.property.shopEnName) {
        descriptionStr += `${data.property.shopCnName}(${data.property.shopEnName}),`;
      } else if (data.property.shopCnName) {
        descriptionStr += `${data.property.shopCnName},`;
      } else if (data.property.shopEnName) {
        descriptionStr += `${data.property.shopEnName},`;
      }

      shopNameStr = descriptionStr;
      descriptionStr += `${data.title}，`;
      if (data.property.address) {
        descriptionStr += `${data.property.address}，`;
      }
      descriptionStr += `电话${phoneFormat(data.property.contactNumber)}，`;

      if (data.property.topics.length > 0 && data.property.topics[0].parent && data.property.topics[0].parent.englishName == 'restaurants') {
        //美食频道
        var restaurantsTitle = '';
        if (data.property.shopCnName == data.property.shopEnName && data.property.shopEnName == data.title) {
          //都重复
          restaurantsTitle = data.property.shopCnName;
        } else if (data.property.shopCnName == data.property.shopEnName && data.property.shopCnName != data.title) {
          restaurantsTitle = `${data.property.shopCnName} - ${data.title}`;
        } else if (data.property.shopCnName == data.title && data.property.shopCnName != data.property.shopEnName) {
          restaurantsTitle = shopNameStr.replace(',', '')
        } else if (data.property.shopEnName == data.title && data.property.shopEnName != data.property.shopCnName) {
          restaurantsTitle = shopNameStr.replace(',', '')
        }
        //shopNameStr = shopNameStr.replace(',','')
        setHtmlMeta({
          title: `${restaurantsTitle} - ${data.property.topics[0].name}(${data.property.topics[0].englishName}) - 多伦多美食 - 约克论坛`,
          keywords: `${shopNameStr},${shopNameStr}优惠,${shopNameStr}地址,${shopNameStr}测评,${shopNameStr}营业时间,多伦多好吃的${shopNameStr}排行榜`,
          description: `${descriptionStr}，营业时间，优惠等一键查询。`
        })

        return
      }


      let keysArr = data.property.topicTags.concat(data.property.customTags);
      let desArr = data.property.customTags.concat(data.property.topicTags);




      if (desArr.length > 0) {
        let descLg = desArr.length > 3 ? 3 : desArr.length;
        let teSe = desArr.splice(0, descLg).map(item => item.name).join(',')
        /* let teSe = desArr.map((item,index)=>{
          if( index <3 ){
            return item.name;
          }
        }).filter(item=>  item.length>0).join(',') */
        descriptionStr += `提供${teSe}等多伦多${this.topic.name}服务。`
      }
      descriptionStr += 'yorkbbs.ca'
      setHtmlMeta({
        title: `${shopNameStr} ${data.title} - ${this.topic.name} - 多伦多黄页 - 约克论坛`,
        //keywords: `${(data.property.customTags || []).map(item => item.name).join(',')}`,
        keywords: `${keysArr.map(item => item.name).join(',')}`,
        description: descriptionStr,
      });
    },
    /**
     * 获取广告
     */
    async getAdvList() {
      const zoomId = 992809559;
      const { data } = await this.$axios.post('/crm/section/v1/get/list/open', { id: zoomId });

      this.adv = bannerAdvConvert(data, 'info', zoomId);

    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  width: 1170px;
  margin: auto;
}

.page-footer {
  margin-top: 100px;
}

.main-wrapper {
  width: 1170px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.page-left {
  width: 830px;
}

.page-right {
  width: 300px;
}

.alert {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--primary-color-lightest);
  color: var(--primary-color);
  font-size: 14px;
  height: 40px;
  padding: 0 20px;
  margin-bottom: 20px;
  border-radius: 4px;
}

.alert-left {
  i {
    margin-right: 10px;
  }
}

.alert-more {
  font-weight: 600;
}

.page-banner__list {
  display: flex;
  height: 263px;
  margin-bottom: 30px;
}

.page-banner__item {
  flex: 1;

  &:not(:last-child) {
    margin-right: 1px;
  }
}

.front {
  padding: 30px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 1px 2px 9px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}

.front-left {
  width: 780px;
}

.front-right {
  width: 260px;
}

.front-images {
  width: 100%;
  height: 195px;
  border-radius: 4px;
  border: 1px solid #eee;
}

.title-wrapper {
  line-height: 30px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.label-optimized {
  height: 22px;
  vertical-align: middle;
  margin-right: 10px;
  vertical-align: middle;
}

.label-vip {
  height: 22px;
  margin-left: 10px;
  vertical-align: middle;
}

.label-unauth {
  display: inline-block;
  font-size: 12px;
  line-height: 24px;
  padding: 0 8px;
  background: #f8f8f8;
  border-radius: 2px;
  color: var(--text-color-6);
  vertical-align: middle;
  margin-left: 10px;
}

.label-year {
  display: inline-block;
  font-size: 12px;
  line-height: 24px;
  padding: 0 8px;
  background: rgba(2, 122, 255, 0.08);
  border-radius: 2px;
  color: #027aff;
  vertical-align: middle;
  margin-left: 10px;
}

.closure {
  font-size: 20px;
  font-weight: 600;
  vertical-align: middle;
  color: #e43a3a;
}

.shopname {
  font-size: 20px;
  font-weight: 600;
  vertical-align: middle;
}

.shopname+.shopname {
  margin-left: 10px;
}

.front-divider {
  height: 1em;
  border-left: 1px solid var(--text-color-3);
  margin: 0 10px;
  vertical-align: middle;
}

.title {
  font-size: 20px;
  vertical-align: middle;
  font-weight: normal;
}

.concat-button__list {
  margin-bottom: 20px;
  display: flex;
}

.concat-button__item {
  margin-right: 10px;

  .el-button {
    height: 40px;
    font-size: 16px;
    padding: 0 16px;

    i {
      font-size: inherit;
      margin-right: 5px;
    }

    .yk-qr-code,
    .yk-sixin {
      color: var(--primary-color);
    }
  }
}

.front-tel {

  display: inline-block;
  text-align: center;
}

.front-button__tel {
  height: 40px;
  font-size: 20px;
  padding: 0 16px;

  i {
    font-size: inherit;
    margin-right: 10px;
  }
}

.front-button__show {
  font-size: 14px;
  color: var(--text-color-9);
  margin-top: 5px;
}

.concat-info__item {
  display: flex;
}

.concat-info__label {
  width: 70px;
  line-height: 30px;
  color: var(--text-color-9);
  font-size: 14px;
}

.concat-info__content {
  flex: 1;
  line-height: 30px;
  font-size: 14px;
  color: var(--text-color-3);

  span,
  button {
    vertical-align: middle;
    line-height: 30px;
  }
}

.concat-info__time {
  display: flex;
  align-items: flex-start;
}

.button-copy {
  line-height: 20px !important;
  height: 20px;
  padding: 0 3px;
  color: var(--text-color-9);
  background-color: #f8f8f8;
  margin-left: 10px;
  font-size: 12px;
}

.concat-website {
  color: #156db6;

  &:hover {
    border-bottom: 1px solid;
  }
}

.concat-status {
  font-weight: 500;
  color: var(--primary-color);
  margin-right: 10px;
}

.concat-time {
  font-weight: 500;
}

.concat-button__more {
  margin-left: 10px;
  color: var(--text-color-9);
}

.front-button__images {
  position: absolute;
  right: 10px;
  bottom: 10px;
  z-index: 1;
  line-height: 28px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  color: #fff;
  padding: 0 10px;
  font-size: 14px;

  i {
    margin-right: 5px;
    font-size: inherit;
  }
}

.front-tool__list {
  padding: 0 25px;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.front-tool__item {
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: var(--text-color-3);

  i {
    font-size: 20px;
  }

  img {
    margin-bottom: 2px;
  }

  &.active {
    color: var(--primary-color);
  }

  &:hover {
    color: var(--primary-color);
  }
}

.detail {
  margin-bottom: 50px;
}

.detail-header {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  margin-bottom: 20px;
}

.detail-tag__list {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.detail-tag__item {
  line-height: 30px;
  padding: 0 10px;
  background: #f8f8f8;
  border-radius: 4px;
  font-size: 14px;
  color: var(--text-color-3);
  margin-right: 10px;
  margin-bottom: 10px;
}

.detail-content {
  padding: 0;
  min-height: 100px;
}

.detail-empty {
  min-height: 100px;
}

.detail-empty__tip {
  text-align: center;
  color: var(--text-color-6);
  margin-top: 100px;

  i {
    font-size: 84px;
    color: var(--text-color-9);
  }

  div {
    font-size: 16px;
    line-height: 22px;
    margin-top: 20px;
  }
}

::v-deep {
  .kjwt-column {
    .kjwt-item {
      margin-bottom: 10px;
    }
  }

  .kjwt-row {
    width: 1170px;
    display: flex;
    margin: 0 auto;

    .kjwt-item {
      margin: 10px 0;
    }

    .kjwt-item+.kjwt-item {
      margin-left: 10px;
    }
  }
}

.info-ranking {
  display: flex;
  flex-wrap: wrap;
  margin-top: 5px;

  .rank-num {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 26px;
    padding: 0 10px 0 0;
    background: #FFEEDF;
    margin: 0 10px 10px 0;
    color: #B15F2D;
    border-radius: 4px;

    .yorkg-rank {
      width: 68px;
      margin-right: 10px;
    }

    .arr-lr {
      width: 5px;
      margin-left: 5px;
    }

    strong {
      margin: 0 5px;
    }

    .rank-name {
      margin-right: 5px;
      position: relative;
      padding-right: 9px;

      &:after {
        position: absolute;
        content: '';
        display: block;
        width: 4px;
        height: 4px;
        border-radius: 2px;
        right: 0;
        top: 50%;
        margin-top: -2px;
        background: #B15F2D;
      }
    }
  }
}

.interact {
  display: flex;
  align-content: center;
  margin-bottom: 30px;
  font-size: 20px;

  li {
    margin-left: 10px;

    &:first-child {
      margin-left: 0;
    }

    .phone-row {
      display: flex;
      align-items: center;
      font-size: 15px;

      img {
        margin-right: 8px;
      }
    }



  }

  i {
    font-size: 20px;
  }

  ::v-deep {
    .el-button {
      padding: 10px 16px;

      &:hover {
        color: var(--text-color-3)
      }
    }
  }
}

.popover-contact {
  .phone-copy {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .phone {
      flex: 1;
      font-size: 22px;
      line-height: 33px;
      color: var(--primary-color);
      font-weight: bold;
    }

    .copy {
      font-size: 14px;
      line-height: 20px;
      color: #333;
      cursor: pointer;
      user-select: none;
      margin-right: 20px
    }
  }

  .contact {
    font-size: 14px;
    line-height: 20px;
    color: var(--text-color-3);
    margin-bottom: 10px;
  }

  .note {
    font-size: 14px;
    line-height: 20px;
    color: var(--text-color-9);
  }
}

.report-row {
  display: flex;
  align-items: center;
  font-size: 15px;

  img {
    height: 20px;
    margin-right: 8px;
  }
}

.qrcode-pic {
  height: 100px;
  width: 100px;
}

.popover-email {
  display: flex;
  align-items: center;
  padding: 0 15px;
  font-size: 14px;
  color: var(--text-color-3);

  .email-cont {
    font-size: 16px;
    font-weight: bold;
    line-height: 36px;
    color: var(--primary-color);
    flex: 1;
  }

  .copy {
    line-height: 20px;
    color: #333;
    cursor: pointer;
    user-select: none;
    margin-right: 20px;
  }

  .send-email {
    line-height: 20px;
  }
}
.collect-btn {
  display: flex;
  align-items: center;
  padding: 0 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  line-height: 40px;
  cursor: pointer;
  user-select: none;

  img {
    display: inline-block;
    height: 20px;
    margin-right: 5px;
  }

  &:hover {
    border-color: #e43a3a;
  }
}
</style>
